module.exports = __webpack_public_path__ + "img/fontWeightWhite.4fe88f7b.svg";